import { ValidationError } from "@se/platform";
import { FormDto } from "@se/platform/forms/dtos/out/formDto";
import { Component } from "./component";
import { FormFieldComponent } from "./formFieldComponent";
import { hide, show } from "../utils";
import { Form } from "./form";
import { IMessagingService } from "../services";

class ValidationSummaryComponent extends Component {

    public formId: string;
    public formDto: FormDto;
    public fieldComponents: FormFieldComponent[] = [];

    private validationTemplateEl: HTMLTemplateElement;
    private validationErrorsEl: HTMLOListElement;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService, private form: Form) {
        super(componentEl, messagingService);

        const formEl = componentEl.closest<HTMLElement>("[data-form-id]");
        this.formId = formEl.dataset["formId"];

        this.validationErrorsEl = componentEl.querySelector<HTMLOListElement>(".js-validation-errors");

        this.validationTemplateEl = componentEl.querySelector<HTMLTemplateElement>(".js-validation-template");

        this.form.onSubmitting$().subscribe(() => this.clearErrors());
        this.form.onValidationErrors$().subscribe(errors => this.showErrors(errors));
        this.form.onAnyValueChanged$().subscribe(response => this.hideError(response.fieldId));
    }

    public showErrors(errors: ValidationError[])
    {
        // add errors to summary
        errors.forEach(error => {
            const fieldId = error.fieldName;

            const template = document.importNode(this.validationTemplateEl, true);
    
            const errorItemEl = template.content.querySelector<HTMLLIElement>(".js-validation-item");
            const errorLinkEl = errorItemEl.querySelector<HTMLAnchorElement>(".js-validation-item-link");
    
            errorItemEl.id = `validation-error-${fieldId}`;
            errorLinkEl.href = `#${fieldId}-field`;
            errorLinkEl.text = error.errorMessage;
    
            this.validationErrorsEl.appendChild(errorItemEl);
        });

        show(this.containerEl)
    }

    public hideError(fieldId: string)
    {
        const validationItemEl = document.getElementById(`validation-error-${fieldId}`);

        if (validationItemEl)
        {
            this.validationErrorsEl.removeChild(validationItemEl);
        }

        // if this was the last error, hide the summary
        if (this.validationErrorsEl.children.length === 0) {
            hide(this.containerEl)
        }

    }

    public focusErrors(){
        if (this.validationErrorsEl) {
            this.validationErrorsEl.focus();
        }
    }

    public clearErrors(){
        hide(this.containerEl);
        this.validationErrorsEl.innerHTML = "";
    }
}

export { ValidationSummaryComponent }